<template>
  <div class="md:flex text-primary-dark " :class="orgId ? 'position-relative':''">
    <section class="md:flex-initial w-56 h-screen fixed bg-gray-100 md:block border-r border-gray-300"
             :class="isOpen ? 'block' : 'hidden'" v-if="orgId">
      <!--      Logo-->
      <div class="flex px-3 text-primary items-center justify-between border-b border-gray-300 h-16">
        <div class="mx-4 text-xl font-bold"> Mashariki BroadBand</div>
        <button @click="isOpen = !isOpen"
                class="mr-2 md:hidden block text-gray-700 md:bg-teal-500 md:hover:bg-teal-600 rounded md:m-1 px-2 pt-1">
          <feather type="x" class="" size="24"></feather>
        </button>
      </div>
      <!-- Navigation links-->
      <div class="px-6 mt-5" v-if="user != null">
        <div class="mt-4"><span class="font-bold">Hello {{ user.first_name }}</span></div>
        <small class="text-gray-700">{{ user.email }}</small>
      </div>

      <ul class="w-full mt-4 text-primary">
        <li class="mb-2 nav-label">
          <span class="uppercase px-6 font-bold">{{ currentOrganization.name }}</span>
        </li>
        <li class="border-l-4 border-transparent hover:border-teal-700" @click="activeMenu = ['home']"
            :class="activeMenu.includes('home') ? 'border-teal-700 bg-gray-200 text-teal-700':''">
          <router-link :to="{name: 'home'}"
                       class="block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700 hover:bg-gray-200">
            <feather type="grid" size="16" class="mr-4"></feather>
            Dashboard
          </router-link>
        </li>
        <li v-if="$store.getters.can('view_networks')" class="border-l-4 border-transparent hover:border-teal-700"
            @click="activeMenu = ['venues']"
            :class="activeMenu.includes('venues') ? 'border-teal-700 bg-gray-200 text-teal-700':''">
          <router-link :to="{name: 'venues'}"
                       class="block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700 hover:bg-gray-200">
            <feather type="share-2" size="16" class="mr-4"></feather>
            Networks
          </router-link>
        </li>
        <li v-if="$store.getters.can('view_splash_pages')" class="border-l-4 border-transparent hover:border-teal-700"
            @click="activeMenu = ['splash_pages']"
            :class="activeMenu.includes('splash_pages') ? 'border-teal-700 bg-gray-200 text-teal-700':''">
          <router-link :to="{name: 'splash_pages'}"
                       class="block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700 hover:bg-gray-200">
            <feather type="tablet" size="16" class="mr-4"></feather>
            Splash Pages
          </router-link>
        </li>
        <li v-if="$store.getters.can('view_clients')" class="border-l-4 border-transparent hover:border-teal-700"
            @click="activeMenu = ['connections']"
            :class="activeMenu.includes('connections') ? 'border-teal-700 bg-gray-200 text-teal-700':''">
          <router-link :to="{name: 'connections'}"
                       class="block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700 hover:bg-gray-200">
            <feather type="activity" size="16" class="mr-4"></feather>
            Connections
          </router-link>
        </li>

        <li class="" v-if="$store.getters.can(['view_clients','view_groups','create_groups'])">
          <div @click="activeMenu =activeMenu.includes('customers_') ? [] : ['customers_']"
               class="relative block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700 hover:bg-gray-200 border-l-4 border-transparent hover:border-teal-700"
               :class="menuActive(['customers_','groups','customers','customer','group']) ? 'border-teal-700 bg-gray-200 text-teal-700':''">
            <feather type="users" size="16" class="mr-4"></feather>
            Customers
            <span class="absolute right-0 items-center">
            <feather
                :type="menuActive(['customers_','groups','customers','customer','group']) ? 'chevron-down': 'chevron-right'"
                size="16" class="mr-3"></feather>
            </span>
          </div>
          <ul class="bg-gray-200 pl-4"
              :class="menuActive(['customers_','groups','customers','customer','group']) ? '':'hidden'">
            <li v-if="$store.getters.can(['view_clients'])" class="border-l-4 border-transparent hover:bg-gray-300"
                @click="activeMenu = ['customers']">
              <router-link :to="{name:'customers', params:{planId: 'free'}}"
                           :class="menuActive(['customers']) ? 'text-teal-700':''"
                           class="block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700">
                <feather type="users" size="16" class="mr-4"></feather>
                Customers
              </router-link>
            </li>
            <li v-if="$store.getters.can(['view_groups'])"
                class="border-l-4 border-transparent hover:bg-gray-300" @click="activeMenu = ['groups']">
              <router-link :to="{name: 'groups'}" :class="menuActive(['groups','group']) ? 'text-teal-700':''"
                           class="block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700">
                <feather type="repeat" size="16" class="mr-4"></feather>
                Groups
              </router-link>
            </li>
            <li v-if="$store.getters.can('create_groups')"
                @click="showModals({modal: 'groups'})" class="border-l-4 border-transparent hover:bg-gray-300">
              <div class="block items-center flex lg:mt-0 px-6 h-10 hover:text-gray-700">
                <feather type="plus-circle" size="16" class="mr-4"></feather>
                New Group
              </div>
            </li>
          </ul>
        </li>
 
        <li class="mt-4 mb-2 nav-label" @click="activeMenu = []">
          <span class="uppercase px-6 font-bold">Marketing</span>
        </li>


        <li class="" v-if="$store.getters.can(['view_broadcasts','create_broadcasts'])">
          <div @click="activeMenu =activeMenu.includes('broadcasts_') ? [] : ['broadcasts_']"
               class="relative block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700 hover:bg-gray-200 border-l-4 border-transparent hover:border-teal-700"
               :class="menuActive(['broadcasts_','broadcasts','broadcast']) ? 'border-teal-700 bg-gray-200 text-teal-700':''">
            <feather type="send" size="16" class="mr-4"></feather>
            Broadcast
            <span class="absolute right-0 items-center">
            <feather
                :type="menuActive(['broadcasts_','broadcasts','broadcast']) ? 'chevron-down': 'chevron-right'"
                size="16" class="mr-3"></feather>
            </span>
          </div>
          <ul class="bg-gray-200 pl-4"
              :class="menuActive(['broadcasts_','broadcasts','broadcast']) ? '':'hidden'">
            <li v-if="$store.getters.can(['view_broadcasts'])"
                class="border-l-4 border-transparent hover:bg-gray-300" @click="activeMenu = ['broadcasts']">
              <router-link :to="{name: 'broadcasts'}"
                           :class="menuActive(['broadcasts','broadcast']) ? 'text-teal-700':''"
                           class="block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700">
                <feather type="send" size="16" class="mr-4"></feather>
                Broadcast Messages
              </router-link>
            </li>
            <li v-if="$store.getters.can('create_broadcasts')"
                @click="showModals({modal: 'broadcast'})" class="border-l-4 border-transparent hover:bg-gray-300">
              <div class="block items-center flex lg:mt-0 px-6 h-10 hover:text-gray-700">
                <feather type="plus-circle" size="16" class="mr-4"></feather>
                New Message
              </div>
            </li>
          </ul>
        </li>

  <div 
    @click="activeMenu = activeMenu.includes('survey_') ? [] : ['survey_']"
    class="relative block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700 hover:bg-gray-200 border-l-4 border-transparent hover:border-teal-700"
    :class="menuActive(['survey_', 'survey']) ? 'border-teal-700 bg-gray-200 text-teal-700':''"
  >
    <feather type="clipboard" size="16" class="mr-4"></feather>
    Survey
    <span class="absolute right-0 items-center">
      <feather
        :type="menuActive(['survey_', 'survey']) ? 'chevron-down': 'chevron-right'"
        size="16" 
        class="mr-3"
      ></feather>
    </span>
  </div>

<!-- Survey Submenu -->
<div v-show="menuActive(['survey_', 'survey'])" class="ml-12 text-sm">
  <router-link 
    :to="{name: 'create_survey'}" 
    class="block px-6 py-2 hover:text-teal-700 hover:bg-gray-100"
    active-class="text-teal-700 font-semibold"
  >
    Create Survey
  </router-link> 

  <router-link 
    :to="{name: 'surveys'}" 
    class="block px-6 py-2 hover:text-teal-700 hover:bg-gray-100"
    active-class="text-teal-700 font-semibold"
  >
    Survey List
  </router-link>

  <router-link 
    :to="{name: 'survey_report'}" 
    class="block px-6 py-2 hover:text-teal-700 hover:bg-gray-100"
    active-class="text-teal-700 font-semibold"
  >
    Survey Analytics
  </router-link>
</div>
<!-- Ads Menu -->
<div
  @click="activeMenu = activeMenu.includes('ads_') ? [] : ['ads_']"
  class="relative block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700 hover:bg-gray-200 border-l-4 border-transparent hover:border-teal-700"
  :class="menuActive(['ads_', 'ads']) ? 'border-teal-700 bg-gray-200 text-teal-700':''"
>
  <feather type="monitor" size="16" class="mr-4"></feather>
  Ads
  <span class="absolute right-0 items-center">
    <feather
      :type="menuActive(['ads_', 'ads']) ? 'chevron-down' : 'chevron-right'"
      size="16"
      class="mr-3"
    ></feather>
  </span>
</div>

<!-- Ads Submenu -->
<div v-show="menuActive(['ads_', 'ads'])" class="ml-12 text-sm">
  <!-- <router-link
    :to="{ name: 'ads_dashboard' }"
    class="block px-6 py-2 hover:text-teal-700 hover:bg-gray-100"
    active-class="text-teal-700 font-semibold"
  >
    Dashboard
  </router-link> -->

  <router-link
    :to="{ name: 'create_ad_campaign' }"
    class="block px-6 py-2 hover:text-teal-700 hover:bg-gray-100"
    active-class="text-teal-700 font-semibold"
  >
    Create Campaign
  </router-link>

  <router-link
    :to="{ name: 'ad_campaigns' }"
    class="block px-6 py-2 hover:text-teal-700 hover:bg-gray-100"
    active-class="text-teal-700 font-semibold"
  >
    Campaign List
  </router-link>

  <router-link
    :to="{ name: 'ad_analytics' }"
    class="block px-6 py-2 hover:text-teal-700 hover:bg-gray-100"
    active-class="text-teal-700 font-semibold"
  >
    Banner Stats
  </router-link>
</div>





        <li v-if="$store.getters.can('view_clients')" class="hidden border-l-4 border-transparent hover:border-teal-700"
            @click="activeMenu = ['connections']"
            :class="activeMenu.includes('connections') ? 'border-teal-700 bg-gray-200 text-teal-700':''">
          <router-link :to="{name: 'connections'}"
                       class="block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700 hover:bg-gray-200">
            <feather type="help-circle" size="16" class="mr-4"></feather>
            Survey
          </router-link>
        </li>
        <li class="mt-4 mb-2 nav-label" @click="activeMenu = []">
          <span class="uppercase px-6 font-bold">Advanced</span>
        </li>
 
        <li class="" v-if="$store.getters.can(['view_bandwidth_policy','view_service_plan'])">
          <div @click="activeMenu =activeMenu.includes('usage') ? [] : ['usage']"
               class="relative block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700 hover:bg-gray-200 border-l-4 border-transparent hover:border-teal-700"
               :class="menuActive(['usage','free_plan','bandwidth_policies','bandwidth_policy']) ? 'border-teal-700 bg-gray-200 text-teal-700':''">
            <feather type="minimize-2" size="16" class="mr-4"></feather>
            Fair Usage
            <span class="absolute right-0 items-center">
            <feather
                :type="menuActive(['usage','free_plan','bandwidth_policies','bandwidth_policy']) ? 'chevron-down': 'chevron-right'"
                size="16" class="mr-3"></feather>
            </span>
          </div>
          <ul class="bg-gray-200 pl-4"
              :class="menuActive(['usage','free_plan','bandwidth_policies','bandwidth_policy']) ? '':'hidden'">
            <li v-if="$store.getters.can(['view_service_plan'])" class="border-l-4 border-transparent hover:bg-gray-300"
                @click="activeMenu = ['free_plan']">
              <router-link :to="{name:'free_plan', params:{planId: 'free'}}"
                           :class="menuActive(['free_plan']) ? 'text-teal-700':''"
                           class="block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700">
                <feather type="shield-off" size="16" class="mr-4"></feather>
                Free plan
              </router-link>
            </li>
            <li v-if="$store.getters.can(['view_bandwidth_policy'])"
                class="border-l-4 border-transparent hover:bg-gray-300" @click="activeMenu = ['bandwidth_policies']">
              <router-link :to="{name: 'bandwidth_policies'}"
                           :class="menuActive(['bandwidth_policies','bandwidth_policy']) ? 'text-teal-700':''"
                           class="block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700">
                <feather type="repeat" size="16" class="mr-4"></feather>
                Bandwidth Policies
              </router-link>
            </li>
          </ul>
        </li>
        <li
  v-if="$store.getters.can(['view_service_plan','view_vouchers','view_subscriptions'])"
  class=""
>
  <div
    @click="activeMenu = activeMenu.includes('prepaid') ? [] : ['prepaid']"
    class="relative block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700 hover:bg-gray-200 border-l-4 border-transparent hover:border-teal-700"
    :class="menuActive(['service_plans','service_plan','prepaid','vouchers','subscriptions','mpesa_transactions']) 
      ? 'border-teal-700 bg-gray-200 text-teal-700' 
      : ''"
  >
    <feather type="credit-card" size="16" class="mr-4"></feather>
    Prepaid
    <span class="absolute right-0 items-center">
      <feather
        :type="menuActive(['prepaid','vouchers','subscriptions','mpesa_transactions']) ? 'chevron-down' : 'chevron-right'"
        size="16"
        class="mr-3"
      ></feather>
    </span>
  </div>

  <ul
    class="bg-gray-200 pl-4"
    :class="menuActive(['service_plans','service_plan','prepaid','vouchers','subscriptions','mpesa_transactions']) ? '' : 'hidden'"
  >
    <!-- Service Plans -->
    <li
      v-if="$store.getters.can(['view_service_plan'])"
      class="border-l-4 border-transparent hover:bg-gray-300"
      @click="activeMenu = ['service_plans']"
    >
      <router-link
        :to="{ name: 'service_plans' }"
        :class="menuActive(['service_plans','service_plan']) ? 'text-teal-700' : ''"
        class="block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700"
      >
        <feather type="layers" size="16" class="mr-4"></feather>
        Service Plans
      </router-link>
    </li>

    <!-- Subscriptions -->
    <li
      v-if="$store.getters.can(['view_subscriptions'])"
      class="border-l-4 border-transparent hover:bg-gray-300"
      @click="activeMenu = ['subscriptions']"
    >
      <router-link
        :to="{ name: 'subscriptions' }"
        :class="menuActive(['subscriptions','subscription']) ? 'text-teal-700' : ''"
        class="block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700"
      >
        <feather type="menu" size="16" class="mr-4"></feather>
        Subscriptions
      </router-link>
    </li>

    <!-- Vouchers -->
    <li
      v-if="$store.getters.can(['view_vouchers'])"
      class="border-l-4 border-transparent hover:bg-gray-300"
      @click="activeMenu = ['vouchers']"
    >
      <router-link
        :to="{ name: 'vouchers' }"
        :class="menuActive(['vouchers']) ? 'text-teal-700' : ''"
        class="block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700"
      >
        <feather type="link-2" size="16" class="mr-4"></feather>
        Vouchers
      </router-link>
    </li>

    <!-- ✅ M-Pesa Transactions (New) -->
    <li
      class="border-l-4 border-transparent hover:bg-gray-300"
      @click="activeMenu = ['mpesa_transactions']"
    >
      <router-link
        :to="{ name: 'mpesa_transactions' }"
        :class="menuActive(['mpesa_transactions']) ? 'text-teal-700' : ''"
        class="block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700"
      >
        <feather type="dollar-sign" size="16" class="mr-4"></feather>
        M-Pesa Transactions
      </router-link>
    </li>
  </ul>
</li>

        <li v-if="$store.getters.can('view_settings')" class="border-l-4 border-transparent hover:border-teal-700"
            @click="activeMenu = ['organization']"
            :class="activeMenu.includes('organization') ? 'border-teal-700 bg-gray-200 text-teal-700':''">
          <router-link :to="{name: 'organization'}"
                       class="block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700 hover:bg-gray-200">
            <feather type="sliders" size="16" class="mr-4"></feather>
            Settings
          </router-link>
        </li>


        <li class="">
          <div @click="activeMenu =activeMenu.includes('reports') ? [] : ['reports']"
               class="relative block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700 hover:bg-gray-200 border-l-4 border-transparent hover:border-teal-700"
               :class="menuActive(['reports']) ? 'border-teal-700 bg-gray-200 text-teal-700':''">
            <feather type="pie-chart" size="16" class="mr-4"></feather>
            Reports
            <span class="absolute right-0 items-center">
            <feather :type="menuActive(['reports',]) ? 'chevron-down': 'chevron-right'"
                     size="16" class="mr-3"></feather>
            </span>
          </div>
          <ul class="bg-gray-200 pl-4" :class="menuActive(['reports']) ? '':'hidden'">
            <li class="border-l-4 border-transparent hover:bg-gray-300">
              <router-link :to="{name: 'reports',params:{ report: 'overview'}}"
                           class="block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700">
                <feather type="activity" size="16" class="mr-4"></feather>
                Overview
              </router-link>
            </li>
            <li class="border-l-4 border-transparent hover:bg-gray-300">
              <router-link :to="{name: 'reports',params:{ report: 'new_visitors'}}"
                           class="block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700">
                <feather type="users" size="16" class="mr-4"></feather>
                First Timers
              </router-link>
            </li>
            <li class="border-l-4 border-transparent hover:bg-gray-300">
              <router-link :to="{name: 'reports',params:{report: 'repeat_visitors'}}"
                           class="block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700">
                <feather type="bar-chart" size="16" class="mr-4"></feather>
                Repeat Customers
              </router-link>
            </li>
            <li class="border-l-4 border-transparent hover:bg-gray-300">
              <router-link :to="{name: 'reports',params:{report: 'all_visitors'}}"
                           class="block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700">
                <feather type="bar-chart" size="16" class="mr-4"></feather>
                All Visitors
              </router-link>
            </li>
            <li class="border-l-4 border-transparent hover:bg-gray-300 hidden">
              <router-link :to="{name: 'reports',params:{report: 'footfall'}}"
                           class="block items-center flex lg:mt-0 px-6 h-8 hover:text-teal-700">
                <feather type="activity" size="16" class="mr-4"></feather>
                Footfall
              </router-link>
            </li>
          </ul>
        </li>


      </ul>
      <div class="flex w-full px-6 absolute bottom-0 right-0 mb-5" :class="activeMenu.includes('home') ? '':'hidden'">
        <label for="toogleA" class="flex items-center cursor-pointer">
          <div class="relative">
            <input id="toogleA" v-model="editMode" type="checkbox" class="hidden"/>
            <div class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
            <div class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"></div>
          </div>
          <div class="ml-3 text-gray-700 font-medium">
            Edit Dashboard
          </div>
        </label>
      </div>
    </section>
    <!--        Content section-->
    <section class="block min-full w-full " :class="orgId ? 'md:pl-56':''">
      <button v-if="isOpen || isSettingsOpen" @click="esc" tabindex="-1"
              class="fixed inset-0 h-full w-full bg-black bg-opacity-25 md:bg-opacity-0 cursor-default"></button>
      <header class="flex w-full px-4 justify-between border-b border-gray-300  h-16">
        <div class="flex md:hidden items-center">
          <button @click="isOpen = !isOpen"
                  class="mr-2 block text-gray-700 md:bg-teal-500 md:hover:bg-teal-600 rounded md:m-1 px-2 pt-1 focus:text-gray-400">
            <feather type="menu" class="" size="24"></feather>
          </button>
          <div class="text-xl font-bold"> BRAND-fi</div>
        </div>
        <input aria-label="Email or phone number" type="text"
               class="hidden md:block appearance-none rounded-md relative block px-3 py-2 bg-transparent
                                        placeholder-gray-500 text-gray-900 focus:outline-none
                                       focus:shadow-outline-blue focus:border-teal-300 focus:z-10 sm:text-sm sm:leading-5"
               placeholder="Search..."/>
        <div class="flex items-center">
          <div class="text-gray-700 hidden md:block lg:block " v-if="orgId">{{ currentOrganization.name }}</div>
          <router-link to="/logout" class="px-3 pt-2  mx-2 hover:text-red-500 block text-gray-700">
            <feather type="power" class="py-auto" size="16"></feather>
          </router-link>
          <div class="mr-4 mt-2 block hover:text-teal-500  text-gray-700">
            <feather type="settings" class="" size="16"></feather>
          </div>
          <div class="">
            <div @click="isSettingsOpen = !isSettingsOpen"
                 class="z-10 block h-6 w-6 rounded-full overflow-hidden focus:outline-none focus:border-white">
              <img class="h-full w-full object-cover" :src="require('@/assets/img/logos/logo.png')" alt="Your avatar">
            </div>
            <div v-if="isSettingsOpen" class="bg-white mt-4 w-64  shadow rounded border absolute right-0"
                 style="z-index: 1">
              <div class="px-6 text-center py-3" v-if="user != null">
                <img class="h-8 w-8 mx-auto object-cover" :src="require('@/assets/img/logos/logo.png')"
                     alt="Your avatar">
                <div class="mt-4"><span class="font-bold">{{ user.name }}</span></div>
                <small class="text-gray-700">{{ user.email }}</small>

                <div class="text-center flex mt-2">
                  <router-link :to="{name: 'profile'}" class="block mx-auto border px-4 rounded-lg py-2">
                    Manage your account
                  </router-link>
                </div>
              </div>
              <div class="border-t mt-2 py-3">
                <router-link :to="{name: 'home', params:{orgId: org.id}}" v-for="org in organizations" :key="org.id"
                             class="block hover:bg-gray-200 px-6 py-1">
                  <div class="font-bold">{{ org.name }}</div>
                  <div class="text-green-500 float-right" v-if="org.id === orgId">Current</div>
                  <div>
                    <small>{{ org.address }}</small>
                  </div>
                </router-link>
                <router-link :to="{name: 'create_organization'}" class="block hover:bg-gray-200 px-6 py-3">
                  Add another organization
                </router-link>

                <div class="text-center flex mt-2">
                  <router-link :to="{name: 'organizations'}" class="block mx-auto border px-4 rounded-lg py-2">
                    Manage your organizations
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div class="w-full">
        <!--Content-->
        <router-view class="md:mx-4"></router-view>
      </div>
    </section>
  </div>
</template>

<script>

import GraphQl from "@/services/graphql.service";

export default {
  name: 'Dashboard',
  components: {},
  data() {
    return {
      activeMenu: [this.$router.currentRoute.name],
      editMode: false,
      isOpen: false,
      isSettingsOpen: false,
      errors: [],
      user: Object,
      currentOrganization: Object,
      organizations: [],
      permissions: [],
      isLoading: true,
    }
  },
  props: {
    orgId: String
  },
  watch: {
    orgId: function (id) {
      this.$store.dispatch('setOrg', id);
      this.$router.go(this.$router.currentRoute)
    },
    editMode: function (editMode) {
      this.$root.$emit("edit_dashboard", editMode);
    }
  },
  created() {
    const handleEscape = (e) => {
      if (e.key === 'Esc' || e.key === 'Escape') {
        this.esc();
      }
    }
    document.addEventListener('keydown', handleEscape)
    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('keydown', handleEscape)
    })
  },
  mounted() {
    this.getProfile();
    this.getMyOrganizations();
  },
  methods: {
    showModals(data) {
      this.$root.$emit("show_modal", data);
    },
    menuActive(paths) {
      let isActive = false;
      paths.forEach((path) => {
        if (!isActive)
          isActive = this.activeMenu.includes(path)
      })
      return isActive;
    },
    esc() {
      this.isOpen = false;
      this.isSettingsOpen = false;
    },
    getProfile: function () {
      GraphQl.sendRequest('{profile {id first_name middle_name last_name email phone_number permissions{identifier} role{name}}}')
          .then(response => {
            this.user = response.profile;
            response.profile.permissions.forEach(permission =>
                this.permissions.push(permission.identifier)
            )
          })
          .finally(() => {
            if (this.user == null)
              this.$router.push("/logout");
            this.$store.dispatch('cachePermissions', this.permissions);
          })
    },
    getMyOrganizations: function () {
      this.axios.get(process.env.VUE_APP_SERVER_URL + '/api/v1/organizations')
          .then((result) => {
            this.organizations = result.data.data.organizations;
            this.organizations.forEach((org) => {
              if (org.id === this.orgId)
                this.currentOrganization = org
            })
          })
          .catch((error) => {
            if (error.response.status === 401)
              this.$router.push("/logout");
          });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nav-label {
  font-size: 10px;
  font-weight: 700;
}

.toggle__dot {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #48bb78;
}
</style>
